module.exports = __webpack_public_path__ + "img/wapRectangle 247@2x.26529881.png";